/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { IObservation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { fhirObservationValueToText } from '../Fhir/fhir_utils';

export function observationValueToText(e: IObservation | undefined, expectedUnits?: string): string | undefined {
  if (!e) return undefined;
  if (e.component) {
    return e.component.map((c: any, i: number) => `(${c.code?.text}: ${observationValueToText(c)})`).join(', ');
  }
  if (e.valueQuantity && (e.valueQuantity.unit === expectedUnits || e.valueQuantity.code === expectedUnits)) {
    return `${e.valueQuantity.value}`;
  }
  return fhirObservationValueToText(e);
}
